<template>
  <div>
<!--    상단-->
    <div class="flex justify-between">
      <div ref="printPhotoUploadGridModulHead">
        <div v-if="customTitle && isShowTitle" style="page-break-before: always">
          <slot name="customTitle"></slot>
        </div>
        <div v-else-if="!customTitle && isShowTitle && !!sectionTitle" class="mt-6 mb-4">
          <h5><i class="dot"></i>{{ sectionTitle }}</h5>
        </div>
      </div>
      <div v-if="isCheckMode && !readonly && !isPrint" class="ml-auto">
        <vs-button color="secondary" @click="handleAdd"> 사진추가 </vs-button>
        <vs-button class="ml-4" color="secondary" type="border" @click="handleRemove"> 선택삭제 </vs-button>
      </div>
    </div>

<!--    테이블 -->
    <table>
      <colgroup>
        <col v-if="isCheckMode && !readonly && !isPrint" width="50" />
        <col width="50" />
        <col />
        <col />
      </colgroup>
      <thead>
        <tr>
          <th v-if="isCheckMode && !readonly && !isPrint">
            <vs-checkbox
              :value="checkData.length === dataList.length && 0 < dataList.length"
              class="justify-center mx-0" @click.native="onClickAllCheckbox" />
          </th>
          <th>No.</th>
          <th>조치 전 사진</th>
          <th>조치 후 사진</th>
        </tr>
      </thead>
      <tbody>
      <tr v-for="(item, item_i) in dataList" :key="`filelist_${item.id}_${item_i}`">
        <th v-if="isCheckMode && !readonly && !isPrint">
          <vs-checkbox v-model="checkData" :vs-value="item.id" class="justify-center mx-0" />
        </th>
        <th>{{ item_i + 1}}</th>
        <td>
          <div v-if="isPrint">
            <div  style="height: 9.5cm; flex: 1" class="flex items-center justify-center overflow-hidden">
              <img :src="item.이전사진.path" width="100%" height="100%" class="max-w-full w-auto object-contain"/>
            </div>
            <p class="print-input mt-2">{{ item.이전사진.input }}</p>
          </div>
          <div v-else>
            <!-- ========== Image ========== -->
            <div class="upload-content__file">
              <div class="upload-content__content">
                <img v-if="isPrint" class="w-full h-full printImg" :src="item.이전사진.thumb" alt="" />
                <FileUploaderTransparent
                  v-else
                  style="background-size: contain; background-repeat: no-repeat"
                  v-model="item.이전사진.image"
                  :readonly="readonly"
                  @input="setFile(item_i, '이전사진', item.이전사진.image)"
                  @progress="(state) => { fileProgress(item_i, '이전사진',  state) }"
                />
              </div>
              <simple-spinner
                v-if="item.이전사진.showSpinner"
                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #cdcdcdaa"
              />
            </div>
            <!-- ========== Footer ========== -->
            <div v-if="isCustomFooter">
              <slot name="customFooter" :index="item_i" :type="'이전사진'"></slot>
            </div>
            <div v-else class="mt-2">
              <p v-if="isPrint">{{ item.이전사진.input }}</p>
              <ml-input v-else v-model="item.이전사진.input" :placeholder="item.이전사진.placeholder" class="w-full flex-1"/>
            </div>
          </div>
        </td>
        <td>
          <div v-if="isPrint">
            <div  style="height: 9.5cm; flex: 1" class="flex items-center justify-center overflow-hidden">
              <img :src="item.이후사진.path" width="100%" height="100%" class="max-w-full w-auto object-contain"/>
            </div>
            <p class="print-input mt-2">{{ item.이후사진.input }}</p>
          </div>
          <div v-else>
            <!-- ========== Image ========== -->
            <div class="upload-content__file">
              <div class="upload-content__content">
                <img v-if="isPrint" class="w-full h-full printImg" :src="item.이후사진.thumb" alt="" />
                <FileUploaderTransparent
                  v-else
                  style="background-size: contain; background-repeat: no-repeat"
                  v-model="item.이후사진.image"
                  :readonly="readonly"
                  @input="setFile(item_i, '이후사진', item.이후사진.image)"
                  @progress="(state) => { fileProgress(item_i, '이후사진', state) }"
                />
              </div>
              <simple-spinner
                v-if="item.이후사진.showSpinner"
                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #cdcdcdaa"
              />
            </div>
            <!-- ========== Footer ========== -->
            <div v-if="isCustomFooter">
              <slot name="customFooter" :index="item_i" :type="'이후사진'"></slot>
            </div>
            <div v-else class="mt-2">
              <p v-if="isPrint">{{ item.이후사진.input }}</p>
              <ml-input v-else v-model="item.이후사진.input" :placeholder="item.이후사진.placeholder" class="w-full flex-1"/>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import FileUploaderTransparent from "@/components/FileUploaderTransparent2";
import SimpleSpinner from "@/components/spinner/SimpleSpinner.vue";

export default {
  name: "PhotoUploadBeforeAfterTable",
  components: {SimpleSpinner, FileUploaderTransparent},
  props: {
    isPrint: Boolean,
    readonly: Boolean,
    id: String,
    value: Array, // [{ id : 0, 이전사진: {}, 이후사진: {} }]
    // 사진리스트 { id:0, fileName:'test1.txt', fileSize:1234, path:'', thumb:'', input:'' }
    isShowTitle: {
      type: Boolean,
      default: true,
    },
    sectionTitle: String,
    customTitle: {
      type: Boolean,
      default: false,
    },
    isCheckMode: {
      type: Boolean,
      default: true,
    },
    isCustomFooter: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value: {
      handler(value) {
        this.dataList = value;
      },
    },
    dataList: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    isPrint: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value) {
          this.$nextTick(() => {
            if (!!this.$refs.printPhotoUploadGridModulHead) this.printHeadHeight = (this.$refs.printPhotoUploadGridModulHead.clientHeight + 100) / 2;
            else this.printHeadHeight = 80;
          });
        }
      },
    },
  },
  data() {
    return {
      printHeadHeight: 80,
      dataList: [],
      checkData: [],
    };
  },
  created() {
    this.fillEmptyFileList();
  },
  methods: {
    generateUniqueId() {
      return '_' + Math.random().toString(36).substr(2, 9);
    },
    fillEmptyFileList() {
      if (this.dataList.length === 0) {
        this.handleAdd()
      }
    },
    // All 체크박스 클릭
    onClickAllCheckbox() {
      if (this.checkData.length === this.dataList.length) this.checkData = [];
      else this.checkData = this.dataList.map((item) => item.id);
    },
    handleAdd() {
      this.dataList.push(
        {
          id: this.generateUniqueId(),
          이전사진: {showSpinner: false },
          이후사진: {showSpinner: false }
        });
    },
    handleRemove() {
      this.dataList = this.dataList.filter((item) => !this.checkData.includes(item.id));
      this.checkData = [];
    },
    setFile(index, type, file) {
      this.dataList[index][type].id = file ? file.id : null;
      this.dataList[index][type].path = file ? file.path : null;
      this.dataList[index][type].fileName = file ? file.fileName : null;
    },
    fileProgress (index, type, state) {
      console.log("fileProgress", index, state)
      if (state === 'start') {
        this.dataList[index][type].showSpinner = true;
      } else if (state === 'success') {
        this.dataList[index][type].showSpinner = false;
        this.$toast.open({type: 'default', message: '이미지 업로드가 완료되었습니다.', position: 'bottom', duration: 2000});
      } else if (state === 'fail') {
        this.dataList[index][type].showSpinner = false;
        this.$toast.open({type: 'error', message: '이미지 업로드가 완료되었습니다.', position: 'bottom', duration: 2000});
      }
    },
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  th,
  td {
    padding: 15px 8px;
    text-align: center;
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: #3c3c3c;
    background: #f9f9f9;
  }

  td {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #3c3c3c;
    box-sizing: content-box;
  }
}

.upload-content__file {
  width: 100%;
  padding-top: 56.25%;
  position: relative;
  border: 1px solid #cdcdcd;
  border-radius: 6px;

  .upload-content__content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-position: center center;
    background-size: cover;

    .printImg {
      background-color: white;
      border-radius: 6px;
    }
  }
}
</style>
